// One outer frame for every route. Reserve scrollbar space in the scroll host,
// independently of the amount of content on a particular page.
export function pageFrameWidth(viewport, available, padding = 24) {
  const space = Math.max(0, Number.isFinite(available) ? available : viewport);
  if (viewport < 1000) return space;
  return Math.min(space, Math.max(1240, viewport * .75 + padding * 2));
}
